// Angular
import { NgModule } from '@angular/core';

// Afidium
import { SectorService } from './sector.service';
import { DateDifferenceModule } from '../date/date-difference/date-diffrence.module';

@NgModule({
    imports: [
        DateDifferenceModule,
    ],
    providers: [SectorService],
})
    export class SectorModule {}